import { render, staticRenderFns } from "./selectTab.vue?vue&type=template&id=f01eecba&scoped=true"
import script from "./selectTab.vue?vue&type=script&lang=js"
export * from "./selectTab.vue?vue&type=script&lang=js"
import style0 from "./selectTab.vue?vue&type=style&index=0&id=f01eecba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01eecba",
  null
  
)

export default component.exports